import React, { useEffect, useMemo } from "react";

import dayjs from "dayjs";
import find from "lodash/find";

import Stack from "@mui/material/Stack";

import SelectController from "../forms/SelectController";
import DatePickerController from "../forms/DatePickerController";
import { getOwners } from "../../helpers/utils";
import useOffices from "../hooks/useOffices";

const startMonth = dayjs().subtract(1, "month").startOf("month");
const endMonth = dayjs().subtract(1, "month").endOf("month");

const SponsorReportForm = ({
  control,
  contacts,
  getValues,
  watch,
  setValue,
}) => {
  const { data: officesData } = useOffices();

  const offices = useMemo(
    () => [{ name: "Pas d'application", id: "none" }, ...officesData],
    [officesData]
  );

  const owners = useMemo(() => {
    const filteredContacts = getOwners(contacts);
    return filteredContacts.map((contact) => ({
      id: contact.contactId,
      name: `${contact.firstName} ${contact.name}`,
    }));
  }, [contacts]);

  const startDate = useMemo(() => getValues("startDate"), [watch("startDate")]);

  const endDate = useMemo(() => getValues("endDate"), [watch("endDate")]);

  useEffect(() => {
    setValue("startDate", startMonth);
    setValue("endDate", endMonth);
  }, []);

  useEffect(() => {
    const officeId = getValues("office");
    const selectedOffice = find(offices, (office) => office.id === officeId);
    setValue("officeData", selectedOffice);
  }, [watch("office")]);

  return (
    <>
      <Stack gap={1}>
        <label className="form-label">Choisissez le propriétaire</label>
        <SelectController
          control={control}
          rules={{ required: true }}
          name="owner"
          options={owners}
          sx={{ backgroundColor: "var(--white)" }}
        />
      </Stack>
      <Stack gap={1}>
        <label className="form-label">Choisissez la période</label>
        <Stack flexDirection="row" gap={1}>
          <DatePickerController
            name="startDate"
            control={control}
            defaultValue={startMonth}
            label="Date de début"
            sx={{ backgroundColor: "var(--white)" }}
            maxDate={endDate}
          />
          <DatePickerController
            name="endDate"
            control={control}
            defaultValue={endMonth}
            label="Date de fin"
            sx={{ backgroundColor: "var(--white)" }}
            minDate={startDate}
          />
        </Stack>
      </Stack>
      <Stack gap={1}>
        <label className="form-label optional">
          Veuillez sélectionner le bureau dans lequel vous avez dupliqué des
          unités:
        </label>
        <SelectController
          control={control}
          name="office"
          defaultValue="none"
          options={offices}
          sx={{ backgroundColor: "var(--white)" }}
        />
      </Stack>
    </>
  );
};

export default SponsorReportForm;
